/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Skeleton, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import {
  CHART_HEIGHT,
  ChartEmpty,
  getProdutividadeChartLayout,
} from '../RelatorioDigitacao/chartShared';
import { mapMaterialToDataset } from './chartShared';
import { formatKgMetric } from './constants';

const MIN_KG_FOR_BAR_LABEL = 50;

const MaterialChart = ({ items, loading, height, onBarClick }) => {
  const theme = useTheme();
  const dataset = useMemo(() => mapMaterialToDataset(items), [items]);
  const chartHeight = height || CHART_HEIGHT;
  const layout = getProdutividadeChartLayout(dataset);

  const barLabelFormatter = useMemo(
    () => (item) => {
      const value = Number(item?.value) || 0;
      if (value < MIN_KG_FOR_BAR_LABEL) return '';
      return formatKgMetric(value);
    },
    [],
  );

  if (loading) {
    return <Skeleton variant="rectangular" height={chartHeight} sx={{ borderRadius: 1 }} />;
  }

  if (!dataset.length) {
    return <ChartEmpty message="Sem dados de materiais no período" />;
  }

  return (
    <Box sx={{ width: '100%', minHeight: chartHeight }}>
      <BarChart
        layout="horizontal"
        height={Math.max(chartHeight, dataset.length * 36)}
        dataset={dataset}
        yAxis={[
          {
            scaleType: 'band',
            dataKey: 'label',
            width: layout.yAxisWidth,
          },
        ]}
        xAxis={[{ label: 'kg' }]}
        series={[
          {
            dataKey: 'totalKg',
            label: 'Peso (kg)',
            color: theme.palette.primary.main,
            valueFormatter: (value) => `${formatKgMetric(value)} kg`,
            barLabel: barLabelFormatter,
          },
        ]}
        margin={layout.margin}
        onItemClick={
          onBarClick
            ? (_, params) => {
                const row = dataset[params?.dataIndex];
                if (row?.tipo) onBarClick(row);
              }
            : undefined
        }
        slotProps={{
          bar: onBarClick ? { style: { cursor: 'pointer' } } : undefined,
          barLabel: {
            style: {
              fill: theme.palette.common.white,
              fontSize: 11,
              fontWeight: 600,
            },
          },
        }}
      />
    </Box>
  );
};

MaterialChart.propTypes = {
  items: PropTypes.array,
  loading: PropTypes.bool,
  height: PropTypes.number,
  onBarClick: PropTypes.func,
};

MaterialChart.defaultProps = {
  items: [],
  loading: false,
  height: null,
  onBarClick: null,
};

export default MaterialChart;
